import React from 'react';
import { motion } from 'framer-motion';
import { BuildingIcon, BriefcaseIcon, TrendingUpIcon, FileTextIcon, GraduationCapIcon, CalendarIcon } from 'lucide-react';
const infoCards = [{
  icon: BuildingIcon,
  title: 'Despre CautLocuinta.ro',
  description: 'Misiunea, valorile și structura organizației.',
  color: 'from-blue-500 to-blue-600'
}, {
  icon: BriefcaseIcon,
  title: 'Departamente & Contact',
  description: 'Datele de contact ale echipelor (HR, fiscal, juridic, suport AI).',
  color: 'from-purple-500 to-purple-600'
}, {
  icon: TrendingUpIcon,
  title: 'Structura carierei',
  description: 'Explică nivelele de carieră și modul de progres.',
  color: 'from-green-500 to-green-600'
}, {
  icon: FileTextIcon,
  title: 'Comisionare & Proceduri',
  description: 'Reguli, procente, modele de calcul.',
  color: 'from-orange-500 to-orange-600'
}, {
  icon: GraduationCapIcon,
  title: 'Traininguri & Masterclass',
  description: 'Link direct către platforma de învățare CLC.',
  color: 'from-indigo-500 to-indigo-600'
}, {
  icon: CalendarIcon,
  title: 'Evenimente & Webinarii',
  description: 'Calendarul actualizat al sesiunilor live.',
  color: 'from-pink-500 to-pink-600'
}];
export function InfoCards() {
  return <section data-id="element-1024">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="text-center mb-12" data-id="element-1025">
        <h2 className="text-3xl md:text-4xl font-bold text-[#132C53] mb-4" data-id="element-1026">
          Informații despre Agenție
        </h2>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto" data-id="element-1027">
          Tot ce trebuie să știi despre CautLocuinta.ro într-un singur loc
        </p>
      </motion.div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1028">
        {infoCards.map((card, index) => <motion.button key={card.title} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: index * 0.1
      }} whileHover={{
        scale: 1.05,
        y: -5
      }} className="bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all text-left group" data-id="element-1029">
            <div className={`w-16 h-16 rounded-xl bg-gradient-to-br ${card.color} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`} data-id="element-1030">
              <card.icon className="w-8 h-8 text-white" data-id="element-1031" />
            </div>
            <h3 className="text-xl font-bold text-[#132C53] mb-3" data-id="element-1032">
              {card.title}
            </h3>
            <p className="text-gray-600" data-id="element-1033">{card.description}</p>
          </motion.button>)}
      </div>
    </section>;
}